import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import TypeAheadDropdown from "components/Global/Fields/TypeAheadDropdown";
import { getAllCompanies } from "store/state/companies";
import "./styles.css";

const CompanyDropdown = ({
  companies,
  getAllCompanies,
  providedCompanies,
  handleChange = () => { },
  selectedSponsorCompanyId
}) => {
  useEffect(() => {
    getAllCompanies(true);
  }, []);

  return (
    <div className="credit-adjustments-company-dropdown-wrapper">
      <div className="credit-adjustments-company-dropdown-text">Company</div>
      <TypeAheadDropdown
        className="credit-adjustments-company-dropdown"
        name="CompanySelection"
        label="companyDropdownCreditAdjustments"
        placeholder="Company"
        handleChange={handleChange}
        options={providedCompanies ? providedCompanies : companies}
        usingFormik={false}
        shouldShow
        selectStyles={{
          indicatorSeparator: provided => ({
            ...provided,
            display: "none"
          }),
          container: provided => ({
            ...provided,
            padding: "0.5em"
          })
        }}
        value={selectedSponsorCompanyId}
      />
    </div>
  );
};

const mapStateToProps = ({ companies }) => ({
  companies: companies.allCompanies ? companies.allCompanies.companies : []
});

export default compose(connect(mapStateToProps, { getAllCompanies }))(CompanyDropdown);
